import script from "./addCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./addCourse.vue?vue&type=script&setup=true&lang=js"

import "./addCourse.vue?vue&type=style&index=0&id=a08d5404&lang=scss&scoped=true"
import "./addCourse.vue?vue&type=style&index=1&id=a08d5404&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a08d5404"]])

export default __exports__